import axios from "axios";

export const getLessonPlans = async (token, queryStr) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CGF_API}/lesson-plan/v1/listing?${queryStr}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};
